export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_CUSTOMER_DETAILS = 'GET_CUSTOMER_DETAILS'
